import * as universal from '../entries/pages/blog/_slug_/_page.ts.js';
import stylesheet_5 from '../stylesheets/5.js';
import stylesheet_6 from '../stylesheets/6.js';

export const index = 6;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/blog/_slug_/_page.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/blog/[slug]/+page.ts";
export const imports = ["_app/immutable/nodes/6.7be9388f.js","_app/immutable/chunks/BlogContentCard.3e416342.js","_app/immutable/chunks/control.f5b05b5f.js","_app/immutable/chunks/scheduler.cba25ae0.js","_app/immutable/chunks/index.e8799153.js","_app/immutable/chunks/each.4a3b5091.js"];
export const stylesheets = ["_app/immutable/assets/6.bfed24c2.css","_app/immutable/assets/BlogContentCard.72565f8f.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/6.bfed24c2.css": stylesheet_5,
	"_app/immutable/assets/BlogContentCard.72565f8f.css": stylesheet_6
});
